import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft2, ArrowRight2 } from "iconsax-react";

const Pagination = ({
  total,
  lastPage,
  current,
  pagination,
  disablePrev = false,
  disableNext = false,
}) => {
  const handlePagination = (newPage) => pagination(newPage);

  const isNextDisabled = disableNext || current === lastPage;
  const isPrevDisabled = disablePrev || current === 1;

  const handlePrev = (e) => {
    if (isPrevDisabled) {
      e.preventDefault();
      return;
    }
    handlePagination(current - 1);
  };

  const handleNext = (e) => {
    if (isNextDisabled) {
      e.preventDefault();
      return;
    }
    handlePagination(current + 1);
  };

  return (
    <div>
      <ul className="flex items-center justify-center gap-3 rounded-full p-1.5">
        {/* Previous Button */}
        <li>
          <Link
            to="#"
            aria-disabled={isPrevDisabled}
            tabIndex={isPrevDisabled ? -1 : 0}
            className={`flex items-center justify-center rounded-full ${
              isPrevDisabled
                ? "cursor-not-allowed opacity-50 pointer-events-none"
                : ""
            }`}
            onClick={handlePrev}
          >
            <ArrowLeft2 size="16" />
          </Link>
        </li>

        {/* Next Button */}
        <li>
          <Link
            to="#"
            aria-disabled={isNextDisabled}
            tabIndex={isNextDisabled ? -1 : 0}
            className={`flex items-center justify-center rounded-full ${
              isNextDisabled
                ? "cursor-not-allowed opacity-50 pointer-events-none"
                : ""
            }`}
            onClick={handleNext}
          >
            <ArrowRight2 size="16" />
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
